import React from 'react';
import { Checkbox } from '../../../blocks/localization';
import { MultilineFormEditorColumnFormat } from '../MultilineFormEditor';

export const checkboxFormat = (options: { isDisabled: (item: any) => boolean }): MultilineFormEditorColumnFormat => {
    return {
        render: (item, column, lineIndex, onChange) => {
            let value = false;
            if (item[column.sourceProperty]) {
                value = item[column.sourceProperty];
            }

            return (
                <Checkbox
                    checked={value}
                    onChange={onChange(column.sourceProperty, lineIndex)}
                    disabled={options.isDisabled(item)}
                />
            );
        },
    };
};
